export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/arrayToObject.js
// module id = 1782
// module chunks = 0